var map = {
	"./dark-logo-large.png": 31901,
	"./dark-logo-medium.png": 18653,
	"./dark-logo-small.png": 25304,
	"./dark-text-logo.png": 33282,
	"./light-logo-large.png": 29251,
	"./light-logo-medium.png": 91801,
	"./light-logo-small.png": 91078,
	"./light-text-logo.png": 69385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70178;